import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EventManager } from '@angular/platform-browser';
import { AuthGuard } from './Services/auth_guard/auth_guard.service';
import { CartGuard } from './Services/auth_guard/protect_cart.service';
import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common';

import { CarouselModule } from 'ngx-owl-carousel-o';
import { HeaderModule } from './Component/Common/header/header.module';
import { FooterComponent } from './Component/Common/footer/footer.component';
import { ReactiveFormsModule } from '@angular/forms';

import { LinkComponent } from './link/link.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';

// import { CarouselModule } from 'ngx-owl-carousel-o';



// import { TimePickerComponent } from './Lazy-loaded-Modules/time-picker/time-picker.component';
// import { MyaccoutKatbookComponent } from './Lazy-loaded-Modules/Account-Modules/myaccout-katbook/myaccout-katbook.component';
// import { SignUpComponent } from './Lazy-loaded-Modules/Account-Modules/sign-up/sign-up.component';
// import { FeedbackFormComponent } from './Lazy-loaded-Modules/feedback-form/feedback-form.component';



@NgModule({
    declarations: [
        AppComponent,
        LinkComponent,

        // SignUpComponent,
        // FeedbackFormComponent
    ],

    bootstrap: [AppComponent], imports: [
        // Global Modules
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CommonModule,
        CarouselModule,
        FooterComponent,
        ReactiveFormsModule,
        HeaderModule,
        // Header and footer modules
        FormsModule,
        NgxImageZoomModule

    ], providers: [AuthGuard, CartGuard, EventManager, DatePipe, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule { }
